var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{staticClass:"change_cursor",class:{ 'on-hover': hover, },attrs:{"elevation":hover ? 12 : 2},on:{"click":function($event){return _vm.openCategory(_vm.category.slug, _vm.category.id)}}},[_c('v-img',{attrs:{"src":_vm.category.image,"aspect-ratio":"1.0"}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }